import { render, staticRenderFns } from "./CartOverview.vue?vue&type=template&id=26a589c7&scoped=true&"
import script from "./CartOverview.vue?vue&type=script&lang=ts&"
export * from "./CartOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CartOverview.vue?vue&type=style&index=0&id=26a589c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a589c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
